<script setup>
import {computed, defineEmits, defineProps, ref, watch} from "vue";
import {couponConf} from "@/utils/config";
import {ElMessage} from "element-plus";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";
import store from "@/store";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf.yuanzu;
    }
  }
});
const emit = defineEmits(['login'])
const step = ref(1);
const coupon = ref({})
const showCoupon = ref(false)
const number = ref(1)
const sendSms = ref(false)
const realname = ref(false)
const loading = ref(false)
const order_from = computed(() => store.state.orderFrom)
const payment = () => {
  if (Object.keys(props.account).length < 1) {
    ElMessage.error("请先登录")
    return
  }
  if (props.type?.login === "scal" && !sendSms.value) {
    sendSms.value = true;
    return;
  }
  sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(props.type.login === 'xm_air' ? {
    access_token: props.account.access_token,
    user_id: props.account.user_id
  } : {cust_id: props.account.cust_id})
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: coupon.value.id,
      uid: props.account.uid,
      pay_type: props.type.login,
      pay_params,
      number: number.value,
      auto_coupon: "1",
      // mobile: ,
      order_from: order_from.value
    }
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    if (props.type.login !== 'xm_air')
      router.replace({name: 'success', params: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
const maxNumber = computed(() => {
  if (Object.keys(props.account).length < 1 || Object.keys(coupon.value).length < 1 || parseFloat(coupon.value.score_data?.[props.type.login]?.total) > parseFloat(props.account.balance_miles)) return 1;
  let num = Math.floor(parseFloat(props.account.balance_miles) / parseFloat(coupon.value?.score_data?.[props.type.login]?.total))
  return num > 10 ? 10 : num
})
const scoreNumber = computed(() => {
  if (Object.keys(coupon.value).length < 1) return 0;
  return parseFloat(coupon.value.score_data?.[props.type.login]?.total) * number.value
})
watch(() => props.account, to => {
  if (Object.keys(to).length && Object.keys(coupon.value).length) {
    // showCoupon.value = true
    pays(coupon.value)
  }
})
const pays = c => {
  coupon.value = c;
  if (Object.keys(props.account).length < 1) {
    emit("login")
    return
  }
  if (parseFloat(props.account.balance_miles) < parseFloat(coupon.value?.score_data?.[props.type.login]?.total)) {
    return ElMessage.error(`可用${coupon.value?.score_data?.[props.type.login]?.unit}不足`);
  }
  showCoupon.value = true
}
</script>

<template>
  <div class="yz-index-product">
    <div class="yz-index-product-title">
      <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/yuanzu/title.png"/>
    </div>
    <div class="yz-index-product-lst" :style="type?.style">
      <el-card shadow="never" v-for="coup in couponLst?.[0]?.data" :key="coup.id">
        <div class="yz-index-product-item">
          <div class="yz-index-product-image">
            <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/yuanzu/product.png"/>
          </div>
          <div class="yz-index-product-info">
            <div class="yz-index-product-name">
              <b class="yz-index-product-face">{{ parseFloat(coup?.face_value) }}</b>
              元祖礼品卡
            </div>
            <div style="margin: 8px auto; display: flex;gap: 8px;align-items: center">
              <div class="yz-index-product-active-tip">
                <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jdjz/hto.png"/>
                <span>9.6折活动价</span>
              </div>
              <div style="margin-bottom: 2px">
                <el-text type="info" style="text-decoration: line-through;">
                  {{ parseFloat(coup?.score_data?.[type?.login]?.discount) }}
                  {{ coup?.score_data?.[type?.login]?.unit }}
                </el-text>
              </div>
            </div>
            <div class="yz-index-product-label">
              <!--              <div class="yz-index-product-price">-->
              <div class="yz-index-product-price">
                <div>
                    <span class="yz-index-product-price-num">{{
                        parseFloat(coup?.score_data?.[type?.login]?.total)
                      }}</span>
                  <span class="yz-index-product-price-unit">{{ (coup?.score_data?.[type?.login]?.unit) }}</span>
                </div>
              </div>
              <!--              </div>-->
              <div class="yz-index-product-label-right">
                <el-button round @click="pays(coup)"
                           v-if="Object.keys(account).length < 1 || parseInt(account?.balance_miles) >= parseInt(coup?.score_data?.[type.login]?.total)">
                  立即兑换
                </el-button>
                <el-button round v-else>
                  {{ coup?.score_data?.[type.login]?.unit }}不足
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
  <div class="yz-index-product-recharge">
    <div class="yz-index-product-step">
      <div class="yz-index-product-step-item" @click="step=1"></div>
      <div class="yz-index-product-step-item" @click="step=2"></div>
      <el-image :src="`https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/yuanzu/recharge-step${step}.png`"/>
    </div>
    <div class="yz-index-product-recharge-info" :style="type?.style">
      <div v-if="step === 1">
        <ol>
          <li>里程兑换商品不提供报销凭证，兑换成功不可退换、转售、兑现、找零；</li>
          <li>
            礼品卡兑换成功后请尽快完成绑定，绑定成功后可在元祖小程序里查看有效期，请在有效期内绑定并使用，过期作废，不退不补；
          </li>
          <li>如需帮助，请拨打服务热线：4000-360-195。</li>
        </ol>
        <p><span style="font-size: 16px;"><b>使用说明</b></span></p>
        <ol>
          <li>持本卡可在中国大陆地区元祖线下门店及【元祖线上门店】微信小程序使用；</li>
          <li>
            礼品卡绑定：兑换成功后，请复制“卡号+密码”，进入微信搜索小程序【元祖线上门店】，底部菜单栏点击【礼卡绑定】→【绑定新卡】输入卡号及密码进行绑定；
          </li>
          <li>礼品卡查看方式：微信搜索小程序【元祖线上门店】→【我的】→【礼卡查询】；</li>
          <li>
            礼品卡消费不含节令性产品(月饼、粽子、玉子、年糕元费等详情依照元祖官方公告)，<b style="color: var(--price-text)">卡内金额可多次使用</b>，用完即止，不可充值；
          </li>
          <li>卡号、卡密请妥善保管，丢失无法找回；</li>
          <li>请在有效期内使用，使用礼品卡不与店内其他优惠活动同享；</li>
          <li>本平台仅是提供会员与商户之间的服务平台，如遇商品质量问题，请及时与商户联系。</li>
        </ol>
      </div>
      <div v-if="step === 2">
        <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/yuanzu/recharge.png"/>
      </div>
    </div>
  </div>
  <el-drawer v-model="showCoupon" direction="btt" class="product-drawer" size="480" :show-close="false"
             style="background: #FAFAFA" v-if="showCoupon" :with-header="false" :style="type?.style">
    <div class="yz-index-product-detail-header">
      <div class="yz-index-product-image">
        <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/yuanzu/product.png"/>
      </div>
      <div>
        <h3>{{ coupon?.name }}</h3>
        <div class="yz-index-product-active-tip" style="margin-bottom: 8px">
          <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jdjz/hto.png"/>
          <span>9.6折活动价</span>
        </div>
        <div class="yz-index-product-price">
          <div>
                    <span class="yz-index-product-price-num">{{
                        parseFloat(coupon?.score_data?.[type?.login]?.total)
                      }}</span>
            <span class="yz-index-product-price-unit">{{ coupon?.score_data?.[type?.login]?.unit }}</span>
          </div>
          <div style="margin-bottom: 3px">
            <el-text type="info">
              {{
                parseFloat(coupon?.score_data?.[type?.login]?.discount)
              }}{{ (coupon?.score_data?.[type?.login]?.unit) }}
            </el-text>
          </div>
        </div>
      </div>
    </div>
    <div class="active-tips">
      兑换成功后，请复制“卡号+密码”，进入【元祖线上门店】微信小程序完成绑定（请于60天内完成绑定），请在有效期内使用（有效期为自绑定成功之日起2年有效）。
    </div>
    <el-card>
      <div class="yz-index-product-items">
        <div>
          兑换数量
        </div>
        <div>
          <el-input-number :min="1" v-model="number" :max="maxNumber"/>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="yz-index-product-items">
        <div>
          可用{{ coupon?.score_data?.[type?.login]?.unit }}
        </div>
        <div>
          {{ account?.balance_miles }}
        </div>
      </div>
      <div class="yz-index-product-items">
        <div>
          支付{{ coupon?.score_data?.[type?.login]?.unit }}
        </div>
        <div>
          {{ scoreNumber }}
        </div>
      </div>
    </el-card>
    <div class="yz-index-btn">
      <el-button round size="large" @click="payment" :loading="loading">立即兑换</el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname"/>
</template>

<style scoped lang="less">
.yz-index-product {
  margin: 15px;

  .yz-index-product-title {
    background: linear-gradient(90deg, #D7A6FF 0%, #F6ECFF 100%);
    box-sizing: border-box;
    padding: 15px;
    border-radius: 12px 12px 0 0;
  }

  .yz-index-product-lst {
    box-sizing: border-box;
    padding: 15px;
    border-radius: 12px;
    background: #ffffff;
    margin-top: -12px;

    .el-card {
      --el-card-border-radius: 12px;

      & + .el-card {
        margin-top: 15px;
      }

      .yz-index-product-item {
        display: flex;
        gap: 12px;

        .yz-index-product-image {
          flex-basis: 80px;
          width: 80px;
        }

        .yz-index-product-info {
          flex-basis: calc(100% - 92px);
          width: calc(100% - 92px);

          .yz-index-product-name {
            box-sizing: border-box;
            padding: 0 10px;
            position: relative;
            display: inline-block;
            z-index: 9;

            .yz-index-product-face {
              font-size: 1.7rem;
            }

            &::after {
              position: absolute;
              content: "";
              height: 5px;
              border-radius: 5px;
              left: 0;
              width: 100%;
              background: #E7E7E7;
              bottom: -3px;
            }
          }

          .yz-index-product-label {
            //margin-top: 10px;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            gap: 5px;

            .yz-index-product-label-left {
              flex-basis: 75%;
              width: 75%;
              //禁止换行
              white-space: nowrap;
            }

            .yz-index-product-label-right {
              .el-button {
                background: var(--btn-color);
                color: #ffffff;
                border: none;
              }
            }
          }
        }
      }
    }
  }
}

.yz-index-product-recharge {
  margin: 15px;

  .yz-index-product-step {
    position: relative;
    height: 55px;
    display: flex;
    align-items: center;

    .yz-index-product-step-item {
      position: relative;
      z-index: 999;
      flex-basis: 50%;
      height: 65px;
      //background: #ffffff;
    }

    .el-image {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }

  .yz-index-product-recharge-info {
    box-sizing: border-box;
    padding: 15px;
    background: #ffffff;
    border-radius: 0 0 12px 12px;
    line-height: 1.6;
    text-align: justify-all;
    font-size: .8rem;

    ol {
      padding-left: 15px;
    }
  }
}

.product-drawer {
  .yz-index-product-detail-header {
    display: flex;
    gap: 12px;
    line-height: 1.5;

    .yz-index-product-image {
      flex-basis: 100px;
      width: 100px;
    }
  }

  .el-drawer__body {
    overflow: unset !important;
  }

  .active-tips {
    margin: 10px auto;
    line-height: 1.65;
    text-align: justify;
    font-size: .9rem;
  }

  .el-card {
    --el-card-border-radius: 12px;
    border: none;

    & + .el-card {
      margin-top: 15px;
    }

    .yz-index-product-items {
      display: flex;
      align-items: center;
      justify-content: space-between;

      & + .yz-index-product-items {
        margin-top: 10px;
        padding-top: 10px;
        border-top: var(--el-border);
      }
    }

  }

  .yz-index-btn {
    margin-top: 15px;

    .el-button {
      width: 100%;
      background: var(--btn-color);
      color: #ffffff;
      border: none;
    }
  }
}

.yz-index-product-active-tip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: .8rem;
  background: #FEF0F3;
  color: #FE0127;
  padding: 3px 10px;
  border-radius: 25px;

  .el-image {
    width: 15px;
    margin-right: 5px;
  }
}

.yz-index-product-price {
  display: flex;
  align-items: end;
  justify-content: space-between;
  font-size: .8rem;
  gap: 10px;

  .yz-index-product-price-num {
    font-size: 1.4rem;
    color: var(--price-text);
  }

  .el-text {
    //删除线
    text-decoration: line-through;
    //font-size: .8rem;
    //margin-bottom: 3px;
  }
}
</style>
